import React from 'react'
import I18n from '../lib/i18n'
import * as StyledComponent from '../styles'
import Analytics from '../lib/analytics'
import Text from '../components/Text'

class EmptyProductSearchResult extends React.Component {
  componentDidMount() {
    const { keyword } = this.props
    if (keyword && keyword.length >= 3) {
      // track event
      Analytics.event({ category: 'Minicart - Search', action: 'Empty Search Result', label: keyword })
    }
  }
  render() {
    const { keyword } = this.props
    return (
      <StyledComponent.EmptyProductSearchResult>
        { keyword && <div className="sorry-message" dangerouslySetInnerHTML={{ __html: I18n.t('empty_product_search_result.title', { keyword }) }} /> }
        <div className='retry-message'>
          <Text text={I18n.t('empty_product_search_result.message')} />
        </div>
      </StyledComponent.EmptyProductSearchResult>
    )
  }
}

export default EmptyProductSearchResult



// WEBPACK FOOTER //
// ./src/components/EmptyProductSearchResult.js